var map = {
	"./img_1.jpg": 59028,
	"./img_10.jpg": 63876,
	"./img_11.jpg": 87458,
	"./img_12.jpg": 63250,
	"./img_2.jpg": 47787,
	"./img_3.jpg": 26253,
	"./img_4.jpg": 36691,
	"./img_5.jpg": 19730,
	"./img_6.jpg": 37431,
	"./img_7.jpg": 94484,
	"./img_8.jpg": 22727,
	"./img_9.jpg": 64514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12745;